import React from 'react'
import AssessmentTable from './AssessmentTable'

function Marking_pending({globalReset,filterIntake,filterLearningMethod,filterSchool,filterLecturer}) {
  return <AssessmentTable globalReset={globalReset} filterIntake={filterIntake} filterLearningMethod={filterLearningMethod} filterLecturer={filterLecturer} filterSchool={filterSchool}/>
}

export default Marking_pending